import { useAtom } from 'jotai';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Libs
import { numberOfWinnersOptions } from '@/lib/giveawayPicker/options';

// Components
import { Select } from '@/components/base/Select/SelectComponent';
// Atoms
import { optionsAtom } from '@/components/pages/giveaway-picker/Atoms/OptionsAtoms';
import { TitleOption } from '@/components/pages/giveaway-picker/OptionsWrapper/components/TitleOption';

const optionsNumberOfWinners = numberOfWinnersOptions;

export const NumberOfWinners = () => {
    const { t } = useTranslation('giveaway_picker');
    const [options, setOptions] = useAtom(optionsAtom);

    const setNumberOfWinners = (value: number) => {
        setOptions((prev) => ({
            ...prev,
            nb_winners: value
        }));
    };

    const selectedOption =
        optionsNumberOfWinners.find((option) => option.value === options.nb_winners) ||
        optionsNumberOfWinners[0];

    return (
        <div className="flex flex-col gap-3" data-testid="number-winners">
            <TitleOption
                title={t('options.number_of_winners')}
                subtitle={t('options.enter_number_of_winners')}
            />
            <Select
                selected={selectedOption}
                setSelected={(option) => setNumberOfWinners(option.value)}
                options={optionsNumberOfWinners}
                data-testid="number-of-winners"
            />
        </div>
    );
};
